import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React, { useEffect, useState } from "react";
import TrackDetails from "./components/track-details";
import useColorThief from "use-color-thief";

import TrackStatus from "./components/track-status";
import styled from "styled-components";
import TrackProgress from "./components/track-progress";
import TrackOptions from "./components/track-options";
import TrackList from "./components/track-list";
import TrackRecordLabel from "./components/trackLabel";
import TrackSplits from "./components/track-splits";
import TrackStores from "./components/track-stores";
import {
  ITrackContributor,
  ITrackRelease,
  ITrackReleaseContainer
} from "types/musicData";
import api from "services/axiosInstance";
import { useParams, useSearchParams } from "react-router-dom";
import DateConvert from "utils/dateConvert";
import { GetTrackData } from "services/getTrack";
import { SongWithUrls, SplitSheet } from "types/response-type";
import { ReleaseContainerWithUrls } from "types/response-type";
import Toast from "components/toast";
import Spinner from "components/spinner";
const TrackPage = () => {
  const [track, setTrack] = useState<SongWithUrls>();
  const [trackContainer, setTrackContainer] =
    useState<ReleaseContainerWithUrls>();

  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const GetData = async () => {
    setLoading(true);
    try {
      const response = await GetTrackData(id || "", type || "");
      if (response) {
        const { track } = response;

        if (type === "SINGLE") {
          let song = track as SongWithUrls;
          setTrack(song);
        } else {
          setTrackContainer(track as ReleaseContainerWithUrls);
        }
      }
    } catch (error) {
      Toast({ error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const { color, palette } = useColorThief(track?.coverArtPath || "", {
    format: "hex",
    colorCount: 2,
    quality: 10
  });

  if (loading) {
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Spinner />
    </div>;
  }

  return (
    <DashboardLayout tint={palette as string[]}>
      <>
        {track ? (
          <>
            <PageLinks
              from={{ name: "Discography", link: "/overview/discography" }}
              current={track?.title}
            />
            <TrackDetails
              coverImg={track.coverArtPath}
              name={track.title}
              artist={track.primaryArtist.name}
              uploadDate={DateConvert(new Date(track.createdAt))}
              relaseDate={DateConvert(new Date(track.proposedReleaseDate))}
              OGReleaseDate={
                track.originalReleaseDate
                  ? DateConvert(new Date(track.originalReleaseDate))
                  : undefined
              }
              type={track.releaseType}
            />
            <Flexbox>
              <TrackProgress />
              <TrackOptions
                id={id || ""}
                type={type || ""}
                name={track.title}
              />
            </Flexbox>
            <TrackStatus
              type="in-progress"
              message={`Your ${track.releaseType} is currently under review or has already been delivered to stores and is now waiting to go live on the scheduled release date.`}
            />
            <TrackList track={track} type="SINGLE" />
            <TrackRecordLabel
              year={track.recordingYear.toString()}
              label={track.label}
            />
            <TrackSplits
              id={id || ""}
              name={track.title}
              splitSheet={
                track.currentSplitSheet ? [track.currentSplitSheet] : []
              }
            />

            <TrackStores
              stores={track.targetStores}
              id={id || ""}
              type={"SINGLE"}
            />
          </>
        ) : trackContainer ? (
          <>
            <PageLinks
              from={{ name: "Discography", link: "/overview/discography" }}
              current={trackContainer?.title}
            />
            <TrackDetails
              coverImg={trackContainer?.coverArtPath}
              name={trackContainer?.title}
              artist={""}
              uploadDate={DateConvert(
                new Date(trackContainer?.tracks[0].createdAt)
              )}
              relaseDate={DateConvert(
                new Date(trackContainer?.tracks[0].proposedReleaseDate)
              )}
              OGReleaseDate={
                trackContainer?.tracks[0].originalReleaseDate
                  ? DateConvert(
                      new Date(trackContainer?.tracks[0].originalReleaseDate)
                    )
                  : undefined
              }
              type={trackContainer.type}
            />
            <Flexbox>
              <TrackProgress />
              <TrackOptions
                id={id || ""}
                type={type || ""}
                name={trackContainer.title}
              />
            </Flexbox>
            <TrackStatus
              type="in-progress"
              message={`Your ${trackContainer.type} is currently under review or has already been delivered to stores and is now waiting to go live on the scheduled release date.`}
            />
            <TrackList tracks={trackContainer.tracks} type="CONTAINER" />
            <TrackRecordLabel
              year={trackContainer.tracks[0].recordingYear.toString()}
              label={trackContainer.tracks[0].label}
            />
            <TrackSplits
              id={id || ""}
              name={trackContainer.title}
              splitSheet={trackContainer.tracks
                .map((track) => track.currentSplitSheet)
                .filter((sheet): sheet is SplitSheet => sheet !== undefined)}
            />

            <TrackStores
              stores={trackContainer.tracks[0].targetStores}
              id={id || ""}
              type={"CONTAINER"}
            />
          </>
        ) : (
          <></>
        )}
      </>
    </DashboardLayout>
  );
};

export default TrackPage;

const Flexbox = styled.div`
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: auto auto;
  margin-top: 7rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: auto;
    grid-row-gap: 3rem;
  }
`;
